import $ from 'jquery';
import Component from '../component';
import template from '../templates/thumbnail.hbs';
import {getCclHtml, toCssString, inherit, makeRequeryUrl} from '../utils';

const isReportMode = SF.getParam('cnucc') === '1';
const LINK_SELECTOR = '.link_thumb';
const IMAGE_SELECTOR = '.thumb_img';
const INFO_SELECTOR = '.info_img';
const INFO_LINK_SELECTOR = '.info_img a.btn_original';

/**
 * 개별 썸네일 HTML을 렌더링 하고 이벤트를 제공
 * @param compConf
 * @param $app
 * @param tabParams
 * @param idx
 * @constructor
 */
function Thumbnail(compConf, $app, tabParams, idx) {
  Component.call(this, compConf);

  this.$app = $app;
  this.setTemplate(template);
  this.state = {
    imageLoaded: false,
    loadStatus: 0
  };
  this.data.tabParams = tabParams;
  this.data.index = idx;
}

inherit(Thumbnail, Component, {
  afterRender() {
    const $app = this.$app;
    this.$img = this.getElement(IMAGE_SELECTOR);
    this.$a = this.getElement(LINK_SELECTOR);
    const thumbnail = this;
    this.addEventListener([LINK_SELECTOR, INFO_SELECTOR].join(','), 'click', function (e) {
      $app.trigger({type: 'thumb:click', originalEvent: e, imageData: thumbnail.data, thumbnail, targetLink: this});
    });
    this.addEventListener(INFO_LINK_SELECTOR, 'click', function (e) {
      e.stopPropagation();
      $app.trigger({type: 'thumbinfo:click', originalEvent: e, imageData: thumbnail.data, thumbnail, targetLink: this});
    });
  },

  toTemplateDataFormat(data) {
    const item = data;
    const dw = Math.floor(item.dw);
    const imageStyle = $.extend({
      width: `${item.iw}px`,
      height: `${item.ih}px`
    }, data.css);

    const infoText = this._getinfoHTML(item.info, data.tabParams);

    const templateData = {
      wrapper_width: dw,
      wrapper_height: item.dh,
      idx: item.index,
      docid: item.docid,
      title: item.info.title,
      htitle: item.info.htitle,
      imageSize: item.iw,
      infoHTML: {
        isNumberType: !!infoText,
        infoText: infoText || item.info.overcpname
      },
      imageUrl: item.url,
      imageStyle: toCssString(imageStyle),
      linkStyle: toCssString({
        width: `${dw - 2}px`,
        height: `${item.dh - 2}px`
      }),
      wrapperStyle: toCssString({
        width: `${dw}px`,
        height: `${item.dh}px`,
        display: item.hide === 'Y' ? 'none' : 'block'
      }),
      originalUrl: item.info.docurl,
      linkUrl: makeRequeryUrl(item.docid, window.location.search),
      isReportMode
    };

    return templateData;
  },

  _getinfoHTML(itemInfo, tabParams) {
    switch (true) {
      case tabParams.Size !== '':
        return `${itemInfo.ow}x${itemInfo.oh}`;
      case tabParams.SortType === 'recency':
      case tabParams.sd !== '' || tabParams.ed !== '':
      case itemInfo.overcpname === '뉴스':
        return itemInfo.regdate;
      case tabParams.CclCommercial !== '' && tabParams.CclDerivative !== '':
        return getCclHtml(itemInfo);
      default:
        return null;
    }
  },

  startImageLoad() {
    if (this.state.imageLoaded) {
      return;
    }
    const $img = this.getElement('img');
    const src = $img.data('src');
    $img.on('load', () => {
      this.state.imageLoaded = true;
      this.state.loadStatus = 200;
      this.$app.trigger({type: 'thumb:IIM-load', $target: $img});
    }).on('error', () => {
      this.state.imageLoaded = true;
      this.state.loadStatus = 404;

    });
    $img.attr('src', src);
  }
});

export default Thumbnail;


/** WEBPACK FOOTER **
 ** ./src/IIM/core/thumb_board/thumbnail.js
 **/